<template>
    <div class="jump-warphd nav-bar-fixed" v-if="showDiv" >
        <van-nav-bar title="银联支付" left-arrow fixed
        @click-left="back" />
        <div class="c-body"  v-if="showDiv">
            <p>订单已提交，请于<span class="red">24小时</span>内完成支付</p>
            <p class="orange">逾期订单将被取消</p>
            <p class="c-desc">由于银行单笔交易额限制，订单金额超过20,000.00元请使用对公账户支付(需电脑支付)</p>
            <p>订单编号: <span class="def-color">{{orderId}}</span></p>
            <p>应付金额: <span class="red" style="font-size:18px;font-weight:600;">{{money}}元</span></p>
            <p v-if="pointAmount>0">积分抵扣金额: <span class="red" style="font-size:18px;font-weight:600;">{{pointAmount}}元</span></p>
            <van-cell title="选择支付方式" class="c-pay">
                <van-radio-group v-model="payment_id">
                    <van-radio v-for="item in paymentCodes" :name="item.id">{{item.name}}</van-radio>
                </van-radio-group>
            </van-cell>
        </div>
        <div class="jump-warphd-foot" >
            <van-button  size="large" @click="pay">提 交</van-button>
        </div>
    </div>
</template>
<script>
import { NavBar,Cell, CellGroup, Field, Button, Row, Col,Radio,RadioGroup  } from "vant";

export default {
  name: "orderpay",
  components: {
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup,
    [Cell.name]:Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Radio.name]:Radio,
    [RadioGroup.name]:RadioGroup
  },
  data() {
    return {
        payment_id:'-1',
        paymentCodes:[],
        id:0,
        money:0,
        orders:'',
        orderId:'',//展示id
        orderIds:'',
        pointAmount:'',//积分抵扣金额
        payHtml:'',
        showDiv:true,
        payUrl:'',
        token: localStorage.getItem("token")
    };
  },
  methods: {
    back(){
        location.href = "#/cart";
        const oIframe = document.getElementById("payIframe");
        oIframe.style.display ="none";
    },
    pay(){
        var that=this;
        if(this.payment_id == '-1'){
            this.$toast('请选择支付方式');
            return;
        }
        that.showDiv=false;
        const oIframe = document.getElementById("payIframe");
        oIframe.src=this.payUrl;
        oIframe.style.display ="block";
         document.querySelector('.wrapper').className = 'wrapper no-header';

    },
    backPaySuccess:function(data){
        location.href = "#/order/success?orderId="+data.orderId+"&orderPrice="+data.price+
            "&pointAmount="+data.usePointAmount+"&getIntegral="+data.getIntegral+
            "&availableQuantity="+data.availableQuantity+"&userIntegral="+data.userIntegral+
            "&integralMsgShow="+data.integralMsgShow;
        const oIframe = document.getElementById("payIframe");
        oIframe.style.display ="none";
    }
  },
    beforeDestroy(){
        const oIframe = document.getElementById("payIframe");
        oIframe.style.display ="none";
        document.querySelector('.wrapper').className = 'wrapper';
    },
  mounted(){
      let that = this;
      window.addEventListener('message',function(event){
          let resultData=event.data;
          if(JSON.stringify(resultData).indexOf("orderId")!=-1){
              that.backPaySuccess(event.data);
          }
      })
    //在线
    that.$api.paymentCodes(successResPay=>{
        if(successResPay.success){
            that.paymentCodes =  successResPay.data;
        }
    })
      this.id = this.$route.query.id;
      this.money = this.$route.query.money;
      this.pointAmount = this.$route.query.pointAmount;
      this.orders = this.$route.query.orders;
      this.orderId = this.$route.query.orderId;
      this.orderIds=this.$route.query.orderIds;
      if(this.orderIds==''||this.orderIds==undefined){
          this.orderIds=this.orders;
      }
      this.payUrl=this.$api.root+"pay/genericUnionPay?payment_id=21&type=goods&childPayType=1&id="+this.id+"&money="+this.money+"&orders="+this.orderIds+"&url="+this.$api.root+"&token="+this.token;
  }
};
</script>
<style lang="less">
@bule-thame: #3C6EEB;
#result .return_merchant{
    display: none!important;
}
.jump-warphd {
   .c-body{
       padding: 10px;
        p{
            font-size: 14px;
            line-height: 38px;
        }
        .c-desc{
            line-height: 22px;
        }
        .c-pay{
            padding: 10px 0;
        }
        .van-radio{
            display: inline-block;
            margin-left: 5px;
        }
   }
    &-foot{
      padding: 10px 15px;
      font-size: 14px;
      button {
        background-color: @bule-thame;
        color: white;
        font-weight: 700;
        border-radius: 5px;
        margin: 25px 0 10px;
      }
    }
}
</style>
